<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
    (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
    [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
    [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bRejectReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="rejectReasonForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Please enter the reject reason</h5>
            <button (click)="closeRejectReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
            <c-input-group class="mb-3 has-validation">
                <span cInputGroupText>Reason</span>
                <textarea [valid]="rejectReasonControl?.valid ? true : false" cFormControl formControlName="rejectReasonControl" id="txtRejectReason"></textarea>
                <c-form-feedback [valid]="rejectReasonControl?.valid ? true : false">
                    {{ isRejectReasonValid() }}
                </c-form-feedback>
            </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeRejectReasonModal()">
                Close
            </button>
            <button cButton (click)="btnRejectConfirm()" color="primary">Confirm</button>
        </c-modal-footer>
    </form>
</c-modal>

<c-modal [visible]="bShowReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Please enter the Transaction ID?</h5>
            <button (click)="closeReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
            <c-input-group class="mb-3 has-validation">
                <span cInputGroupText>
                    Transaction ID
                </span>
                <input [valid]="bValidReason" cFormControl formControlName="reasonControl" id="RejectReason"
                    type="text" />
                <c-form-feedback [valid]="ifReasonValid() === ''?true:false">{{ifReasonValid()}}</c-form-feedback>
            </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeReasonModal()">
                Close
            </button>
            <button cButton (click)="confirm()" color="primary">Confirm</button>
        </c-modal-footer>
    </form>
</c-modal>

<div *ngIf="!decisionSaveModel">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
        <c-container fluid>
            <form cForm class="row" [formGroup]="cifSearchForm" (ngSubmit)="getServices()">

                <c-row [gutter]="{gy: 1}">
                    <c-col lg="6">
                        <c-date-range-picker [startDate]="startDate" [endDate]="endDate"
                            (startDateChange)="onStartDateChane($event)" [disabledDates]="disabledDates"
                            (endDateChange)="onEndDateChane($event)"></c-date-range-picker>
                    </c-col>
                    <c-col lg="1" class="flex-align-center">
                        <div >
                            <h6 >Status:</h6>
                        </div>
                        
                    </c-col>
                    <c-col lg="4">
                        <c-input-group class="has-validation">
                            <!-- <c-form-check [switch]="true">
                                <input cFormCheckInput formControlName="toogle" type="checkbox" />
                                <label class="margin-top-5" cFormCheckLabel>Pending Items </label>
                            </c-form-check> -->
                            
                            <select cSelect  formControlName="toogle">
                                
                                <option selected value="">All Remittances</option>
                                <option value="Pending">Outstanding/Open Remittances</option>
                                <option value="Approved">Approved/Completed Remittances</option>
                                <option value="Rejected">Rejected/Failed Remittances</option>
                            </select>
                        </c-input-group>
                    </c-col>
                    <c-col lg="1">
                        <button cButton type="submit">
                            Search
                        </button>
                    </c-col>
                </c-row>
            </form>
        </c-container>
    </c-navbar>
    <c-smart-table 
    [columnSorter]="true" 
    [columns]="columns" 
    [columnFilter]="true" 
    [itemsPerPageSelect]="true"
    [itemsPerPage]="10" 
    [items]="serviceData" 
    [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }" 
    
    (rowClick)="rowSelected($event); " 
    clickableRows
    header 
    pagination>
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
        <td>
            <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchCase="'status'">
                    <c-badge [color]="getStatusBadge(item)">
                        {{(item.status)}}
                    </c-badge>
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'img'">
                    <c-badge >
                        <img [src]="item.img" />
                    </c-badge>
                </ng-container> -->
                <ng-container *ngSwitchDefault>
                    {{tdContent}}
                </ng-container>
            </ng-container>
        </td>
    </ng-template>
    </c-smart-table>

</div>
<div *ngIf="decisionSaveModel" class="save-model">
    <div class="main-height">
        <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
            <c-container fluid>
                <b>Swift Transfers Details</b>
                <button [cNavbarToggler]="toolbarCollapseRef"></button>
                <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
                    <c-navbar-nav class="me-auto mb-2 mb-lg-0">

                    </c-navbar-nav>
                    <form cForm class="d-flex" role="search">
                        <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="goBackToSearchScreen()"><svg
                                cIcon name="cilChevronDoubleLeft"></svg>
                            Back
                        </button>
                        <button *ngIf="checkActionVisibility()" (click)="showRejectReasonModal()" cBgColor="danger" cTooltip="Reject" cTooltipPlacement="top" style="margin: 5px;"
                            cButton><svg cIcon name="cilX"></svg>
                            Reject</button>
                        <div *ngIf="checkApproveVisibility()">
                            <button *ngIf="checkActionVisibility()" cBgColor="success"
                            cTooltip="Approve" cTooltipPlacement="top" style="margin: 5px;" cButton
                            (click)="showReasonModal()"><svg cIcon name="cilCheck"></svg>
                        Approve
                        </button>
                        </div>

                    </form>
                </div>
            </c-container>
        </c-navbar>
        <div class="g-2 pt-4 main-class">
            <div class="row">
                <div class="col-md-9">
                    <div class="table-view">
                        <label>Branch Name:</label> {{rowDataDetail?.branchName}}
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="table-view">
                        <label>Transfer Type:</label> {{rowDataDetail.transferType }}
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="head">Sender</div>
                <div class="row padding-left-10">
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>CIF:</label> {{rowDataDetail?.cif}} - {{rowDataDetail?.senderName}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Account Name:</label> {{rowDataDetail?.accountName}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Account Number:</label> {{rowDataDetail?.senderAccountNumber}}
                        </div>
                    </div>

                </div>
            </div>
            <div class="section">
                <div class="head">Recipient</div>
               
                <div class="row padding-left-10">
                    <div class="col-md-3">
                        <div class="table-view">
                            <label>Current Compliance Approval Status: </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="table-view amlstatus-css"> 
                            <label>{{rowDataDetail?.latestAmlstatus}}</label>
                        </div>
                    </div>
                    <div class="col-md-3" *ngIf="!amlstatus">  
                        <div *ngIf="!rowDataDetail?.isDecisionTaken" (click)="updateBeneficiaryId()" class="button-app">Update</div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Beneficiary Bank Name:</label> {{rowDataDetail?.benBankName}}
                        </div>
                    </div>                          
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Name:</label> {{rowDataDetail?.benName}}
                        </div>
                    </div>
                    
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Address:</label> {{rowDataDetail?.benAddress}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient City:</label> {{rowDataDetail?.benCity}}
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Country:</label> {{rowDataDetail?.benCountry}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Identification Type:</label> {{rowDataDetail?.benIdtype}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Identification Number:</label> {{rowDataDetail?.benIdnumber}}
                        </div>
                    </div>
                </div>



            </div>
            <div class="section">
                <div class="head">Transaction Details</div>
                <div class="row padding-left-10">
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Date & Time:</label> {{rowDataDetail?.transactionDate | date:'full'}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Status: </label> 

                            <span *ngIf="rowDataDetail?.status">
                                <c-badge [color]="getStatusBadge(rowDataDetail)">
                                    <label>
                                        {{rowDataDetail?.status }}
                                    </label>
                                </c-badge>
                            </span>
                            
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Reference No:</label> {{rowDataDetail?.transactionId}}
                        </div>
                    </div>
              
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Account/IBAN:</label> {{rowDataDetail?.benAccountNumber}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Routing Code:</label> {{rowDataDetail?.benRoutingCode}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Recipient Swift Code:</label> {{rowDataDetail?.benSwiftCode}}
                        </div>
                    </div>
                    
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transfer Currency :</label> {{rowDataDetail?.transferCurrency }}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transfer Amount:</label> {{rowDataDetail?.transferAmount }}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Amount in words:</label> {{rowDataDetail?.transferAmountInWords}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Dhabi Charges:</label> {{rowDataDetail?.charges}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view"> 
                            <label>Charges:</label> {{rowDataDetail?.chargesCode}}
                        </div>
                    </div>
                    
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Purpose:</label> {{rowDataDetail?.purpose}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Purpose Code:</label> {{rowDataDetail?.purposeCode}}
                        </div>
                    </div>
                    
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Decision Taken By: <span *ngIf="rowDataDetail?.isDecisionTaken">{{rowDataDetail?.decisionTakenBy}}</span></label>
                            
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Decision Taken On: <span *ngIf="rowDataDetail?.isDecisionTaken">{{rowDataDetail?.decisionTakenOn | date:'full'}}</span></label>
                            
                        </div>
                    </div>




                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Purpose 1:</label> {{rowDataDetail?.transactionPurpose1}}
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Purpose 2:</label> {{rowDataDetail?.transactionPurpose2}}
                        </div>
                    </div>
                    
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Purpose 3: </label> {{rowDataDetail?.transactionPurpose3}}
                            
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="table-view">
                            <label>Transaction Purpose 4: </label> {{rowDataDetail?.transactionPurpose4}}
                            
                        </div>
                    </div>


<!-- 
                    tx.TransactionPurpose1 = transfer.TransactionPurpose1;
                    tx.TransactionPurpose2 = transfer.TransactionPurpose2;
                    tx.TransactionPurpose3 = transfer.TransactionPurpose3;
                    tx.TransactionPurpose4 = transfer.TransactionPurpose4; 
-->




                    <!-- <div class="col-md-12">
                        <div class="table-view">
                            <label *ngIf="rowDataDetail?.isDecisionTaken">Is Approved: Yes</label>
                            <label *ngIf="!rowDataDetail?.isDecisionTaken">Is Approved: No</label>
                        </div>
                    </div> -->
                   
                    <!-- <div class="col-md-8">
                        <div class="table-view">
                            <label *ngIf="rowDataDetail?.isDecisionTaken && rowDataDetail?.isApproved">Transaction Reference Number: {{rowDataDetail?.transactionId}}</label>
                            <label *ngIf="!rowDataDetail?.isDecisionTaken && !rowDataDetail?.isApproved">Transaction Reference Number: </label>
                        </div>
                    </div> -->



                </div>
            </div>
        </div>
    </div>